import React from 'react';
import { Collapse, Empty } from 'antd';
import { FormattedMessage } from 'react-intl';

interface EvidencePack {
    perQuestionTiming: unknown | null;
    fingerprintBreakdown: unknown | null;
    biometricSamples: unknown | null;
    attentionCheckResults: unknown | null;
    llmJudgeFull: unknown | null;
    embeddingVectors: unknown | null;
    ipReputation: unknown | null;
    rawRequestHeaders: unknown | null;
}

interface EvidencePackViewerProps {
    evidence: EvidencePack | null | undefined;
}

const SECTIONS: Array<{ key: keyof EvidencePack; label: string }> = [
    { key: 'perQuestionTiming', label: 'responseIntegrity.evidence.timing' },
    { key: 'fingerprintBreakdown', label: 'responseIntegrity.evidence.fingerprint' },
    { key: 'biometricSamples', label: 'responseIntegrity.evidence.biometrics' },
    { key: 'attentionCheckResults', label: 'responseIntegrity.evidence.attentionChecks' },
    { key: 'llmJudgeFull', label: 'responseIntegrity.evidence.llmJudge' },
    { key: 'embeddingVectors', label: 'responseIntegrity.evidence.embeddings' },
    { key: 'ipReputation', label: 'responseIntegrity.evidence.ipReputation' },
    { key: 'rawRequestHeaders', label: 'responseIntegrity.evidence.requestHeaders' },
];

const renderJson = (value: unknown): React.ReactNode => (
    <pre
        style={{
            background: '#fafafa',
            padding: 12,
            borderRadius: 4,
            overflow: 'auto',
            maxHeight: 400,
            margin: 0,
            fontSize: 12,
        }}
    >
        {JSON.stringify(value, null, 2)}
    </pre>
);

export const EvidencePackViewer: React.FC<EvidencePackViewerProps> = ({
    evidence,
}) => {
    if (!evidence) {
        return (
            <Empty
                description={<FormattedMessage id="responseIntegrity.evidence.empty" />}
            />
        );
    }

    const present = SECTIONS.filter(
        (s) => evidence[s.key] !== null && evidence[s.key] !== undefined,
    );

    if (present.length === 0) {
        return (
            <Empty
                description={<FormattedMessage id="responseIntegrity.evidence.empty" />}
            />
        );
    }

    return (
        <Collapse
            items={present.map((s) => ({
                key: s.key,
                label: <FormattedMessage id={s.label} />,
                children: renderJson(evidence[s.key]),
            }))}
        />
    );
};
